import cn from 'classnames/bind';
import React, { FC } from 'react';

import styles from './ChannelProgramModalHeader.module.css';

const cx = cn.bind(styles);

interface Props {
    title: string;
    img: string;
}

export const ChannelProgramModalHeader: FC<Props> = ({ title, img }) => (
    <div className={cx('root')}>
        <img src={img} className={cx('logo')} alt="" />
        <span className={cx('title')} dir="auto">
            {title}
        </span>
    </div>
);
